import { FC, useMemo } from 'react'

import { AppointmentModel } from '@models/appointment'

import dayjs from '@/libs/dayjs'

import { AppointmentAgendaBubble } from '../AppointmentAgendaBubble'
import { AppointmentAgendaEmpty } from '../AppointmentAgendaEmpty'

type Agenda = {
  formattedDate: string
  date: string
  time: string
  children: Array<AppointmentModel>
}

type Props = {
  withDate?: boolean
  appointments: Array<AppointmentModel> | undefined
}

const AppointmentAgendaTimeline: FC<Props> = ({ withDate, appointments }) => {
  const agendas: Array<Agenda> = useMemo(() => {
    const bucketAgenda: Array<Agenda> = []

    appointments?.forEach((appointment) => {
      const startDate = new Date(appointment.started_at!)
      const formattedDate = dayjs(startDate).format('YYYY-MM-DD HH:mm')
      const date = dayjs(startDate).format('MMM-DD')
      const time = dayjs(startDate).format('HH:mm')

      const existIndex = bucketAgenda.findIndex((a) => a.time === formattedDate)
      if (existIndex !== -1) {
        bucketAgenda[existIndex].children.push(appointment)
      } else {
        bucketAgenda.push({
          formattedDate,
          date,
          time,
          children: [appointment],
        })
      }
    })

    return bucketAgenda
    // eslint-disable-next-line
  }, [appointments])

  if (agendas.length === 0) {
    return <AppointmentAgendaEmpty />
  }

  return (
    <div className="timeline-label">
      {agendas.map((agenda) => (
        <div
          className="timeline-item"
          key={agenda.time}
        >
          <div className="timeline-label fw-medium text-gray-800 fs-7">
            {withDate && <div>{agenda.date}</div>}
            <div>{agenda.time}</div>
          </div>
          <div className="timeline-badge">
            <i className="fa fa-genderless text-secondary fs-1"></i>
          </div>
          <div className="timeline-content ms-3">
            {agenda.children.map((appointment) => (
              <AppointmentAgendaBubble
                appointment={appointment}
                key={appointment.id}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}

export { AppointmentAgendaTimeline }
